import axios from "axios";
import store from "@/store";
import { isAuth } from "@/services/user";
import { ResponseError } from "@/model/error/ajax";
import { message } from "ant-design-vue";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // baseURL: "http://10.255.0.105",
  // baseURL: "http://127.0.0.1:7001",
  timeout: 30000
});

service.interceptors.request.use(
  request => {
    if (isAuth()) {
      request.headers.Authorization = store.getters.authTokenInfo;
    }
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (
      response.data &&
      response.data.code &&
      parseInt(response.data.code) !== 0
    ) {
      const error = new ResponseError({
        code: response.data.code,
        message: response.data.msg
      });
      return Promise.reject(error);
    }
    return response;
  },
  error => {
    console.log(error);
    console.log(error.code);
    console.log(error.message);
    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1
    ) {
      message.error(`请求超时，请稍后再试`);
    } else if ("Network Error" === error.message) {
      message.error(`网络错误，请检查网络连接`);
    }
    return Promise.reject(error);
  }
);

export default service;
